module.exports = __webpack_public_path__ + "static/wpack/extracted/penguin-group7203ec7b6258397f036e6fb1ce454c6b.png";